// types
import { type ModuleType as ExpensiveOrigin } from "./_definitions"
import { type State } from "../../types"

export const expensiveoriginSelector = (state: State): ExpensiveOrigin => state.expensiveOrigin
